<template>
  <v-dialog v-model="dialog" max-width="500px" persistent content-class="rounded-lg">
    <v-card class="dialog-card">
      <!-- Header -->
      <div class="employee-form-header px-4 py-3">
        <span class="text-h6 font-weight-bold text-gray-900">Edit Attendance</span>
        <v-btn icon small @click="closeDialog">
          <v-icon color="grey">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="form-content pa-4">
        <!-- Timing Section -->
        <div class="form-section form-content-border">
          <h4 class="section-title">
            <!-- <v-icon color="primary" class="mr-2">mdi-clock-outline</v-icon> -->
            Alter {{ column }} Timing
          </h4>
          <div class="section-content">
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="currentTime"
                  label="Time"
                  type="time"
                  outlined
                  dense
                  required
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </div>

        <!-- Location Section -->
        <div class="form-section form-content-border mb-4">
          <h4 class="section-title">
            <!-- <v-icon color="primary" class="mr-2">mdi-map-marker-radius-outline</v-icon> -->
            Alter {{ column }} Address
          </h4>
          <div class="section-content">
            <v-row>
              <v-col cols="12" class="py-0">
                <CommonAutocomplete
                  @selected-place="handleSelectedPlace"
                  hide-details
                  outlined
                  dense
                  placeholder="Search for a location..."
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>

      <!-- Actions -->
      <div class="form-actions">
        <v-btn outlined color="grey darken-1" class="cancel-btn" @click="closeDialog">
          Cancel
        </v-btn>
        <v-btn
          :color="$vuetify.theme.currentTheme.primary"
          class="save-btn white--text"
          elevation="0"
          @click="saveDialogData"
        >
          Save
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import CommonAutocomplete from '~/components/CommonAutoComplete.vue'
dayjs.extend(customParseFormat)

export default {
  components: {
    CommonAutocomplete
  },
  props: {
    dialog: Boolean,
    time: String,
    column: String
  },
  data() {
    return {
      currentTime: this.convertTimeTo24HourFormat(this.time),
      address: '',
      latitude: '',
      longitude: ''
    }
  },
  watch: {
    time(newValue) {
      this.currentTime = this.convertTimeTo24HourFormat(newValue)
    }
  },
  methods: {
    convertTimeTo24HourFormat(time) {
      return time ? this.$dayjs(time, 'hh:mm A').format('HH:mm') : ''
    },
    handleSelectedPlace(val) {
      this.latitude = val.location.lat()
      this.longitude = val.location.lng()
      this.address = val.formatted_address
    },
    closeDialog() {
      this.$emit('update:dialog', false)
      this.address = '' // Reset address on close if desired, matching original intent
      this.latitude = ''
      this.longitude = ''
    },
    saveDialogData() {
      this.$emit('save', {
        time: this.currentTime,
        address: this.address,
        latitude: this.latitude,
        longitude: this.longitude
      })
      this.closeDialog()
    }
  }
}
</script>

<style scoped>
.employee-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
}

.form-content {
  background-color: #f8f9fa;
  /* Ensure it takes full height if content is short, but for dialog auto is fine */
}

.form-section {
  /* margin-bottom: 10px; */
}

.form-section:last-child {
  margin-bottom: 0;
}

.form-content-border {
  width: 100%;
  border-radius: 4px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.section-title {
  font-size: 1rem;
  font-weight: 500;
  color: #21427d;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-content {
  padding-left: 0; /* Adjusted from 8px for dialog width constraints */
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
  background-color: #f8f9fa;
  border-top: 1px solid #e0e0e0;
  gap: 12px;
}

.cancel-btn {
  min-width: 100px;
  text-transform: none;
  font-weight: 500;
}

.save-btn {
  min-width: 140px;
  text-transform: none;
  font-weight: 500;
}

/* Dark theme support */
:deep(.theme--dark) .form-content,
:deep(.theme--dark) .employee-form-header,
:deep(.theme--dark) .form-actions {
  background-color: #2a2a2a;
  border-color: #444;
}

:deep(.theme--dark) .form-content-border {
  background-color: #2d2d2d;
  border-color: #444;
}

:deep(.theme--dark) .section-title {
  color: #8cb6e1;
}
</style>
